var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"metrics",attrs:{"data-count":_vm.count}},[(_vm.title)?_c('div',{staticClass:"metrics-title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('div',{staticClass:"metrics-wrapper"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }